import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { forWorkUpgradeTariff } from 'reactApp/appHelpers/featuresHelpers/features/forWorkUpgrade';
import { upgradeSubscriptionEnabled } from 'reactApp/appHelpers/featuresHelpers/features/upgradeSubscription';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { upgradeSubscriptionPlanRequest } from 'reactApp/modules/upgradeSubscription/upgradeSubscription.module';

export const useUpgradeSubscription = () => {
    const dispatch = useDispatch();
    const subscriptions = useSelector(BillingDataSelectors.sortSubscriptionsBySpace);
    const subId = subscriptions[0]?.id;

    useEffect(() => {
        if (upgradeSubscriptionEnabled && subId && forWorkUpgradeTariff) {
            dispatch(
                upgradeSubscriptionPlanRequest({
                    sub_id: subId,
                    product_id: forWorkUpgradeTariff,
                })
            );
        }
    }, [upgradeSubscriptionEnabled, subId, forWorkUpgradeTariff]);
};
